var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Command from '../Command';
import Signals from '../../signals/Signals';
import createUser from '../../requests/user/createUser';
/**
 *
 */
var CreateUserCommand = /** @class */ (function (_super) {
    __extends(CreateUserCommand, _super);
    function CreateUserCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param user User
     * @param suppressNotification bool
     * @param intl
     * @return {*}
     */
    CreateUserCommand.prototype.execute = function (user, suppressNotification, intl) {
        if (suppressNotification === void 0) { suppressNotification = false; }
        this.user = user;
        this.suppressNotification = suppressNotification;
        this.intl = intl;
        var promise = createUser(user);
        promise.then(this.then);
        promise.catch(this.catch);
        return promise;
    };
    CreateUserCommand.prototype.then = function (response) {
        if (!this.suppressNotification) {
            Signals.ShowNotification.dispatch(this.intl.formatMessage({ id: 'notification.user.added' }), this.user, 'dark', true);
        }
    };
    return CreateUserCommand;
}(Command));
export default CreateUserCommand;
